var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "filter-default-multiselect",
    _vm._g(
      _vm._b(
        {
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(slotProps) {
                return [
                  _c("custom-select-color-dropdown-content", {
                    attrs: {
                      options: slotProps.options,
                      "selected-options": slotProps.selectedOptions
                    },
                    on: { add: slotProps.add, remove: slotProps.remove }
                  })
                ]
              }
            }
          ])
        },
        "filter-default-multiselect",
        _vm.$props,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }